// extracted by mini-css-extract-plugin
export default {"paper":"styles_paper__Z+gS6","position":"styles_position__K2Sro"};